import React from 'react';
import cx from 'classnames';
import { Link as RouterLink } from 'react-router-dom';
import LinkProps from './Link.types';
import styles from './Link.module.scss';
import buttonStyles from '../Button/Button.module.scss';
import { TextColor } from '../../shared/types/textColor.types';

const Link = ({
  children,
  href,
  className,
  internalLink,
  to,
  dataCy = 'link',
  styleAsButton = false,
  styleAsInlineButton = false,
  target = '_blank',
  fontColor = TextColor.Primary,
  ...props
}: LinkProps) => {
  if (internalLink)
    return (
      <RouterLink
        data-cy={dataCy}
        className={cx(className, {
          [styles.link]: !styleAsButton,
          [buttonStyles.contained]: styleAsButton,
          [buttonStyles.btn]: styleAsButton,
          [buttonStyles.primary]: styleAsButton,
          [styles.buttonLink]: styleAsButton,
          [styles[fontColor]]: !styleAsButton,
        })}
        to={to}
        {...props}>
        {children}
      </RouterLink>
    );
  return (
    <a
      data-cy={dataCy}
      data-testid='Link'
      className={cx(className, {
        [styles.link]: !styleAsButton && !styleAsInlineButton,
        [buttonStyles.contained]: styleAsButton || styleAsInlineButton,
        [buttonStyles.btn]: styleAsButton || styleAsInlineButton,
        [buttonStyles.primary]: styleAsButton || styleAsInlineButton,
        [styles.buttonLink]: styleAsButton,
        [styles.inlineButtonLink]: styleAsInlineButton,
        [styles[fontColor]]: !styleAsButton,
      })}
      rel='noopener noreferrer'
      href={href}
      target={target}
      {...props}>
      {children}
    </a>
  );
};

export default Link;
